module.exports = __webpack_public_path__ + "img/gfuzum-1.7890b916.png";